export enum UserRole {
  SUPERUSER = "super_admin",
  ADMIN_SITE = "admin_site",
  CLIENT = "subscriber",
}
